module.exports = __webpack_public_path__ + "static/media/podcast-header-background-mobile.305e9c23.png";